var exports = {
  "Qs": "x234b8571--32c23e--content",
  "su": "x234b8571--32c23e--icon-wrapper",
  "R_": "x234b8571--32c23e--heading",
  "qr": "x234b8571--32c23e--footer",
};

module.exports = exports;
